import { render } from "./Header-component.vue?vue&type=template&id=4335abd3&scoped=true&style=width%3A100%25"
import script from "./Header-component.vue?vue&type=script&lang=js"
export * from "./Header-component.vue?vue&type=script&lang=js"

import "./Header-component.vue?vue&type=style&index=0&id=4335abd3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4335abd3"]])

export default __exports__